import React, { useContext, useEffect, useState } from "react";
import logo from "../../images/logo.png";
import { NavLink, useLocation } from "react-router-dom";
import { RiQuestionnaireFill } from "react-icons/ri";
import { RiHome5Fill } from "react-icons/ri";
import "../../stylesheet/prescription.css";
import { useSelector, useDispatch } from "react-redux";
import { toggleSideBar } from "../../reducers/sideBarReducer";
import { FaTimes } from "react-icons/fa";
import { TbPrescription } from "react-icons/tb";
import { FaHospitalUser } from "react-icons/fa6";
import { FaBookBookmark } from "react-icons/fa6";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { FaUsersBetweenLines } from "react-icons/fa6";
import { MdOutlineInventory } from "react-icons/md";
import { MdLiveHelp } from "react-icons/md";
const Links = [
  {
    id: 1,
    icon: <RiHome5Fill />,
    text: "Dashboard",
    to: "/dashboard",
  },
  {
    id: 2,
    icon: <TbPrescription />,
    text: "Prescriptions",
    to: "/prescription",
  },
  {
    id: 3,
    icon: <FaHospitalUser />,
    text: "Patients",
    to: "/patients",
  },
  {
    id: 4,
    icon: <FaBookBookmark />,
    text: "Appointments",
    to: "/appointments",
  },

  {
    id: 5,
    icon: <LiaFileInvoiceDollarSolid />,
    text: "Billings",
    to: "/billings",
  },
  {
    id: 6,
    icon: <FaUsersBetweenLines />,
    text: "Partners",
    to: "/partners",
  },
  {
    id: 7,
    icon: <MdOutlineInventory />,
    text: "Inventory",
    to: "/inventory",
  },

  {
    id: 8,
    icon: <MdLiveHelp />,
    text: "Help-Desk",
    to: "/help-desk",
  },
];

const SideBarPanel = () => {
  return (
    <div className="max-w-[15rem]">
      <img src={logo} alt="logo" />
      <div className="nav_link">
        {Links.map((item) => (
          <NavLink
            to={item.to}
            key={item.id}
            className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "active" : ""
            }
          >
            {item.icon} <span>{item.text}</span>
          </NavLink>
        ))}
      </div>
      <div className="log_out">
        <NavLink to="./login" className="log-out">
          <RiQuestionnaireFill />
          <span>Logout</span>
        </NavLink>
      </div>
    </div>
  );
};

const Sidebar = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.appStore.sideBar.status);
  const [showSidebar, setSideBar] = useState(false);

  useEffect(() => {
    const response = Links.find((links) => {
      return links.to == `${location.pathname}`;
    });

    if (response) {
      setSideBar(true);
    }
    // debugger;
    if (location.pathname.split("/").length <= 2) {
      dispatch(toggleSideBar(false));
    }
  }, [location]);
  return (
    <>
      {showSidebar && (
        <main className="main-side md:flex w-full h-screen md:overflow-hidden justify-center">
          <>
            <aside className="sidebar_nav hidden lg:block w-full lg:w-3/12 xl:w-2/12 sticky border-r overflow-auto pl-10 min-w-[15rem]">
              <SideBarPanel />
            </aside>

            {status && (
              <dialog className="mobile block lg:hidden relative">
                <div
                  className="absolute right-5 top-5 cursor-pointer"
                  onClick={() => {
                    dispatch(toggleSideBar(!status));
                  }}
                >
                  <FaTimes size={20} />
                </div>
                <div className="h-screen bg-white rounded-md p-8 border flex justify-start">
                  <SideBarPanel />
                </div>
              </dialog>
            )}
          </>
          <section
            className={`w-full lg:w-10/12 lg:overflow-hidden lg:overflow-y-scroll overflow-auto ${
              status && "hidden lg:block"
            }`}
          >
            {children}
          </section>
        </main>
      )}
    </>
  );
};

export default Sidebar;
